module.exports = __webpack_public_path__ + "img/秒杀专场.33c5b6ce.svg";